import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "border-t border-hairline py-10 px-6 md:px-8" }
const _hoisted_2 = { class: "container mx-auto max-w-5xl" }
const _hoisted_3 = { class: "flex flex-col md:flex-row md:items-baseline md:justify-between gap-6 mb-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-serif-display text-lg text-ink mb-1" }, "Juan Alonso Rodríguez"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-subtle text-sm max-w-[44ch]" }, " Java Backend Developer — Spring Boot, APIs REST e integraciones empresariales en el sector bancario. ")
], -1)
const _hoisted_5 = { class: "flex flex-wrap gap-x-6 gap-y-2" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "border-t border-hairline pt-6 flex flex-col md:flex-row justify-between gap-2 text-sm text-subtle" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://linkedin.com/in/juan-alonso-rodriguez-rivera-0b88291aa",
  target: "_blank",
  rel: "noopener",
  class: "hover:text-indigo2 transition-colors"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fab fa-linkedin-in mr-1" }),
  /*#__PURE__*/_createTextVNode(" LinkedIn ")
], -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterPortafolio',
  setup(__props) {

const enlacesRapidos = [
  { nombre: 'Sobre Mí', url: '#about' },
  { nombre: 'Experiencia', url: '#experience' },
  { nombre: 'Habilidades', url: '#skills' },
  { nombre: 'Back-end', url: '#backend' },
  { nombre: 'Front-end', url: '#frontend' },
  { nombre: 'Contacto', url: '#contact' },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("nav", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(enlacesRapidos, (link, index) => {
            return _createElementVNode("a", {
              key: index,
              href: link.url,
              class: "text-sm text-subtle hover:text-indigo2 transition-colors"
            }, _toDisplayString(link.nombre), 9, _hoisted_6)
          }), 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", null, "© " + _toDisplayString(new Date().getFullYear()) + " Juan Alonso Rodríguez", 1),
        _hoisted_8
      ])
    ])
  ]))
}
}

})